// Portado de aw-ava/app/src/componentes/ui/button.tsx (kit aprovado pelo PO). Mudou só o caminho dos imports.

import { Slot } from '@radix-ui/react-slot'
import { cva, type VariantProps } from 'class-variance-authority'
import { Loader2 } from 'lucide-react'
import * as React from 'react'
import { cn } from '../cn'

const variantes = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full font-semibold transition-[background,color,box-shadow,transform] duration-150 active:scale-[.98] disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 cursor-pointer',
  {
    variants: {
      variante: {
        primario: 'bg-primary text-on-primary hover:brightness-110 shadow-(--bt-sombra)',
        secundario: 'bg-surface text-text border border-(--bt-borda) hover:bg-surface-2',
        fantasma: 'bg-transparent text-text-2 hover:bg-surface-2 hover:text-text',
        suave: 'bg-primary-soft text-primary-texto hover:brightness-95',
        perigo: 'bg-erro text-white hover:brightness-110',
        // linha de base 2 (ui-kit/02): o Perdido da página da oportunidade, o Ganho e o Atender do Balcão ao vivo
        perigoSuave: 'bg-erro-soft text-erro hover:brightness-95',
        ok: 'bg-ok text-white hover:brightness-110',
        atender: 'bg-[var(--calor-vivo,var(--ok))] text-[var(--calor-vivo-texto,white)] hover:brightness-105',
        link: 'text-primary-texto underline-offset-4 hover:underline h-auto p-0 rounded-none',
      },
      tamanho: {
        md: 'h-(--ctl-h) px-5 text-sm',
        sm: 'h-(--ctl-h-sm) px-3.5 text-(length:--bt-texto-sm)',
        lg: 'h-(--ctl-h-lg) px-6 text-[15px]',
        icone: 'size-(--ctl-h) p-0',
        iconeSm: 'size-(--ctl-h-sm) p-0',
      },
    },
    defaultVariants: { variante: 'primario', tamanho: 'md' },
  },
)

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof variantes> {
  asChild?: boolean
  carregando?: boolean
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variante, tamanho, asChild = false, carregando, children, disabled, ...props }, ref) => {
    if (asChild) {
      // Slot exige um único filho: o link/elemento recebe as classes e pronto.
      return (
        <Slot className={cn(variantes({ variante, tamanho, className }))} ref={ref} {...props}>
          {children}
        </Slot>
      )
    }
    return (
      <button
        className={cn(variantes({ variante, tamanho, className }))}
        ref={ref}
        disabled={disabled || carregando}
        {...props}
      >
        {carregando ? <Loader2 className="animate-spin" /> : null}
        {children}
      </button>
    )
  },
)
Button.displayName = 'Button'

export { variantes as buttonVariants }
